/**
 * This is a wrapper around Stripe's APIs that we use in our frontend code.
 * Expose the APIs that we need from Stripe.js here so we have a single place
 * to look at during API upgrades and refactors.
 */

import type { StripeType } from 'js/src/typings/global';

const STRIPE_API_VERSION = '2025-01-27.acacia';

const PaymentService = (() => {
    let singletonInstance: StripeType = null;

    const getInstance = () => {
        if (!singletonInstance) {
            if (!window) {
                throw new Error('Window object is not available!');
            }
            if (!window.Stripe) {
                throw new Error('Stripe.js has not been loaded!');
            }
            singletonInstance = window.Stripe(SERVER.STRIPE_PUBLISHABLE_KEY, {
                apiVersion: STRIPE_API_VERSION,
            });
        }
        return singletonInstance;
    };

    return {
        confirmCardPayment: (clientSecret: string) => {
            return getInstance().confirmCardPayment(clientSecret);
        },
        redirectToCheckout: (sessionId: string) => {
            return getInstance().redirectToCheckout({ sessionId });
        },
    };
})();

export default PaymentService;
